import { render } from "./LoginPassword.vue?vue&type=template&id=c32317bc&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import "./LoginPassword.vue?vue&type=style&index=0&id=c32317bc&lang=scss&scoped=true"
import "./LoginPassword.vue?vue&type=style&index=1&id=c32317bc&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c32317bc"]])

export default __exports__